<mat-card (click)="handleClick()" class="card">
  <mat-card-content>
    <ng-container
      [ngTemplateOutlet]="cardTemplate ?? defaultCardTemplate"
      [ngTemplateOutletContext]="{ $implicit: item }"
    ></ng-container>
  </mat-card-content>
</mat-card>

<ng-template #defaultCardTemplate let-item>
  {{ item | json }}
</ng-template>
